<template>
  <Dropdown
    :button-class="` ${buttonClass} group relative contact-button`"
    :chevron-size="0"
    :fullscreen="!$windowSize.isDesktop"
    :y-offset="10"
  >
    <template #label-icon>
      <div ref="chatButton" class="">
        <lucide-icon icon="MessagesSquare" :size="22 * iconScale" />
        <lucide-icon
          v-if="!hideContacts"
          icon="PhoneCall"
          :size="20 * iconScale"
        />
        <template v-if="!hideSocials">
          <lucide-icon
            v-if="socialPresence.Telegram"
            class="group-not-[.btn-primary]:text-telegram"
            icon="Telegram"
            :size="26 * iconScale"
          />
          <lucide-icon
            v-if="socialPresence.Whatsapp"
            class="group-not-[.btn-primary]:text-whatsapp"
            icon="Whatsapp"
            :size="26 * iconScale"
          />
          <lucide-icon
            v-if="socialPresence.Viber"
            class="group-not-[.btn-primary]:text-viber"
            icon="Viber"
            :size="24 * iconScale"
          />
          <lucide-icon
            v-if="socialPresence.Link"
            class=""
            icon="Link"
            :size="20 * iconScale"
          />
        </template>
      </div>
    </template>

    <template #title>
      {{ $t('titles.Contact') }}
    </template>
    <template #content="{ closeDropdown }">
      <template v-if="!hideSocials">
        <a
          v-for="(link, index) in contacts?.links"
          :key="index"
          :href="link.link"
          class="hover:text-primary group mb-0.5 flex h-10 items-center rounded-lg px-2 text-sm transition-colors hover:bg-gray-100 dark:hover:bg-neutral-700 md:h-9"
          target="_blank"
          @click="closeDropdown"
        >
          <lucide-icon
            v-if="link.social == 'Telegram'"
            class="text-telegram me-2"
            icon="Telegram"
            size="22"
          />
          <lucide-icon
            v-if="link.social == 'Whatsapp'"
            class="text-whatsapp me-2"
            icon="Whatsapp"
            size="24"
          />
          <lucide-icon
            v-if="link.social == 'Viber'"
            class="text-viber me-2"
            icon="Viber"
            size="20"
          />
          <lucide-icon
            v-if="link.social == 'Link'"
            class="me-2"
            icon="Link"
            size="18"
          />

          <span>{{ link.social }}</span>
        </a>
      </template>

      <a
        v-if="!hideContacts"
        class="hover:text-primary mb-0.5 flex h-10 items-center rounded-lg px-2 text-sm transition-colors hover:bg-gray-100 dark:hover:bg-neutral-700 md:h-9"
        :href="`tel:${mainPhone}`"
      >
        <lucide-icon class="me-3" icon="PhoneCall" size="16" />
        <span>
          {{ mainPhone }}
        </span>
      </a>
      <a
        v-if="secondaryPhone && !hideContacts"
        class="hover:text-primary mb-0.5 flex h-10 items-center rounded-lg px-2 text-sm transition-colors hover:bg-gray-100 dark:hover:bg-neutral-700 md:h-9"
        :href="`tel:${secondaryPhone}`"
      >
        <lucide-icon class="me-3" icon="PhoneCall" size="16" />
        <span>
          {{ secondaryPhone }}
        </span>
      </a>
      <a
        v-if="catalogSettings?.allow_requests"
        class="hover:text-primary mb-0.5 flex h-10 items-center justify-center rounded-lg px-2 text-sm transition-colors hover:bg-gray-100 dark:hover:bg-neutral-700 md:h-9"
        href="#"
        @click.prevent="
          closeDropdown();
          OPEN_MODAL({ type: 'callback' });
        "
      >
        {{ $t('control.callback') }}
      </a>

      <!-- <a
          v-if="
            tokenSettings?.type != 'App\\Models\\ProjectGroup' &&
            tokenSettings?.id != 87
          "
          class="justify-content-start d-flex btn btn-white btn-hover-primary w-100"
          href="#"
        >
          {{ $t('control.callback') }}
        </a> -->
    </template>
  </Dropdown>
</template>
<script>
import Dropdown from '@/components/ui/Dropdown';

import { mapActions, mapGetters } from 'vuex';
import { formatPhoneNumber } from '@dmlnc/hello_world_phone';

export default {
  name: 'LinksDropdown',
  components: {
    Dropdown,
  },
  props: {
    buttonClass: {
      type: String,
      default: '',
    },
    iconScale: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      interval: null,
    };
  },
  computed: {
    ...mapGetters(['catalogSettings', 'hideContacts', 'hideSocials']),

    socialPresence() {
      const links = this.contacts?.links || [];
      return {
        Viber: links.some((link) => link.social === 'Viber'),
        Telegram: links.some((link) => link.social === 'Telegram'),
        Whatsapp: links.some((link) => link.social === 'Whatsapp'),
        Link: links.some((link) => link.social === 'Link'),
      };
    },
    contacts() {
      return this.catalogSettings?.contacts;
    },
    mainPhone() {
      return formatPhoneNumber(this.contacts?.phone);
    },
    secondaryPhone() {
      return formatPhoneNumber(this.contacts?.secondary_phone);
    },
  },

  watch: {
    contacts: {
      immediate: true,
      handler: function () {
        this.buttonLoop();
      },
    },
  },
  mounted() {
    // this.buttonLoop();
  },
  methods: {
    ...mapActions(['OPEN_MODAL']),
    async buttonLoop() {
      await this.$nextTick();
      let i = 1;
      let icons = this.$refs.chatButton.querySelectorAll('svg');

      clearInterval(this.interval);
      this.interval = null;
      for (let j = 0; j < icons.length; j++) {
        icons[j].classList.remove('show');
      }

      if (icons.length > 1) {
        icons[0].classList.add('show');
        icons[0].classList.remove('one');
        this.interval = setInterval(function () {
          if (i == 0) {
            icons[i].classList.add('show');
          } else if (i == icons.length) {
            icons[i - 1].classList.remove('show');
            icons[0].classList.add('show');
            i = 0;
          } else {
            icons[i - 1].classList.remove('show');
            icons[i].classList.add('show');
          }
          i++;
        }, 3000);
      } else {
        icons[0].classList.add('one');
      }
    },
  },
};
</script>
<style scoped lang="scss">
.contact-button {
  overflow: hidden;
  & svg {
    opacity: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotateY(90deg);
    // transition: opacity 0.4s;
    position: absolute;

    &.show {
      animation-name: rotateAnimation;
      animation-duration: 3s;
      animation-timing-function: ease-in-out;
      animation-iteration-count: 1;
      // transform: translate(-50%,-50%) rotateY(90deg);
      opacity: 1;
    }

    &.one {
      transform: translate(-50%, -50%) rotateY(0deg);
      opacity: 1;
    }
  }
}

@keyframes rotateAnimation {
  0% {
    transform: translate(-50%, -50%) rotateY(90deg);
  }

  10% {
    transform: translate(-50%, -50%) rotateY(0deg);
  }

  90% {
    transform: translate(-50%, -50%) rotateY(0deg);
  }

  100% {
    transform: translate(-50%, -50%) rotateY(90deg);
  }
}
</style>
